export const ON_CLICK_EVENTS = {
  ON_CATEGORY_EXPANDED: 'onCategoryExpanded',
  ON_CATEGORY_COLLAPSED: 'onCategoryCollapsed',
  ON_CATEGORY_SELECTED: 'onCategorySelected',
  ON_SUBCATEGORY_ADD_CLICK: 'onSubcategoryAddClick',
  ON_SUBCATEGORY_ADD_CANCEL_CLICK: 'onSubcategoryAddCancelClick',
  ON_SUBCATEGORY_ADDED: 'onSubcategoryAdded',
  ON_SUBCATEGORY_EDIT_CLICK: 'onSubcategoryEditClick',
  ON_SUBCATEGORY_EDIT_CANCEL_CLICK: 'onSubcategoryEditCancelClick',
  ON_SUBCATEGORY_DELETE_CLICK: 'onSubcategoryDeleteClick',
  ON_SUBCATEGORY_DELETED: 'onSubcategoryDeleted',
  ON_SUBCATEGORY_SAVED: 'onSubcategorySaved',
}
